var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { color: _vm.color } },
    [
      _vm.mode === "DESIGN"
        ? _c(
            "div",
            { staticClass: "description" },
            [
              _c("el-icon", { staticClass: "el-icon-warning-outline" }),
              _vm._v(_vm._s(_vm.placeholder) + " "),
            ],
            1
          )
        : [
            !_vm.readerMode
              ? _c(
                  "div",
                  { staticClass: "description description-input" },
                  [
                    _c("el-icon", { staticClass: "el-icon-warning-outline" }),
                    _vm._v(_vm._s(_vm.placeholder) + " "),
                  ],
                  1
                )
              : [
                  !_vm.showDetail
                    ? _c(
                        "div",
                        { staticClass: "description description-show" },
                        [
                          _c("el-icon", {
                            staticClass: "el-icon-warning-outline",
                          }),
                          _vm._v(_vm._s(_vm.placeholder)),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }